import { UserCollectionGroupType } from '@/types/schema';

import { useUserCollectionGroupQuery } from '../graphql/queries/generated/userCollectionGroup';

export default function useUserCollectionGroup({
  groupId,
  pause,
}: {
  groupId: string;
  pause?: boolean;
}) {
  const [{ data, fetching, error }] = useUserCollectionGroupQuery({
    variables: {
      filters: {
        id: groupId,
      },
    },
    pause: !groupId || pause,
  });

  return {
    group: data?.group as UserCollectionGroupType | undefined,
    fetching,
    error,
  };
}
